import { render, staticRenderFns } from "./ClientListContainerView.vue?vue&type=template&id=8b7a9cbe&"
import script from "./ClientListContainerView.vue?vue&type=script&lang=js&"
export * from "./ClientListContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports